import {Component, Pipe, PipeTransform, Injectable} from '@angular/core';
import { Park } from '../../dataTypes/Park';

@Pipe({
  name: 'editPermissionTranslatePipe',
    pure: false
})
@Injectable()
export class editPermissionTranslatePipe implements PipeTransform {

  transform(filter: number): string {
       
   //רמת הרשאה 0.עדכון\הוספה\מחיקה 1.עיון בלבד
    if (filter === 1)
      return 'עיון בלבד';
    if (filter === 0)
      return 'עדכון';
    }
}
